import React, { useEffect, useRef, useState } from "react";

/**
 * Scroll-reveal dengan SATU IntersectionObserver dikongsi untuk semua
 * elemen (lebih ringan daripada satu observer per komponen).
 */
const callbacks = new WeakMap();
let observer = null;

function getObserver() {
  if (observer || typeof IntersectionObserver === "undefined") return observer;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const cb = callbacks.get(entry.target);
        if (!cb) return;
        if (entry.isIntersecting) {
          cb(true);
          if (cb.once) {
            observer.unobserve(entry.target);
            callbacks.delete(entry.target);
          }
        } else if (!cb.once) {
          cb(false);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  );
  return observer;
}

export default function Reveal({
  children,
  variant = "up",
  delay = 0,
  className = "",
  once = true,
  as: Tag = "div",
}) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = getObserver();
    if (!obs) {
      setShown(true);
      return;
    }
    const cb = (visible) => setShown(visible);
    cb.once = once;
    callbacks.set(el, cb);
    obs.observe(el);
    return () => {
      obs.unobserve(el);
      callbacks.delete(el);
    };
  }, [once]);

  return (
    <Tag
      ref={ref}
      className={`reveal reveal--${variant} ${shown ? "is-visible" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
}
